export default "__VITE_ASSET__BbSIgm1Q__"